// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__E5tce","notes":"Notes_notes__18NDQ"};